export default __webpack_public_path__ + "static/media/glitch10.ab2d29ef.png";